export default __webpack_public_path__ + "static/media/zonaexpo_2023_english.f8b6ad68.jpg";